import { CodeBase } from "./_codeBase";


/** 担当区分*/
export class ChargeDiv extends CodeBase<ChargeDiv>
{
    /** 担当区分: "01", "（空白）", "（空白）"*/
    public static readonly NONE: ChargeDiv = new ChargeDiv("01", "　", "　");

    /** 担当区分: "02", "一般ユーザ(機器・工事別担当ユーザ)、権限あり(作業別担当ユーザ)" "○"*/
    public static readonly ORDINARY: ChargeDiv = new ChargeDiv("02", "一般ユーザ(機器・工事別担当ユーザ)、権限あり(作業別担当ユーザ)", "○");

    /** 担当区分: "03", "機器工事の代表者", "☆"*/
    public static readonly REPRESENTER: ChargeDiv = new ChargeDiv("03", "機器・工事の代表者", "☆");


    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ChargeDiv[] {
        return [
            ChargeDiv.NONE,
            ChargeDiv.ORDINARY,
            ChargeDiv.REPRESENTER,

        ];
    }
}

